import { registerPlugin } from '@capacitor/core';

export interface HmsPushPlugin {
  getPushProvider(): Promise<{ provider: 'FCM' | 'HMS' }>;
  register(): Promise<{ token: string | null }>;
}

export const HmsPush = registerPlugin<HmsPushPlugin>('HmsPush');
